export default [
    "24 24",
    '<path d="M4 12H20M20 12L14 6M20 12L14 18"  fill="none" stroke="var(--ci-primary-color, currentColor)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>']

